
const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;

export const ExpireLink = async (Id, Token, toast, fetchPaymentRequests, setIsModalOpen) => {
    const url = `${API_Payment_URL}Requests/ExpireLink`;
    const data = {
      Id: Id,
      Token: Token
    };
  
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      
        return errorDetails;
      }

      const result = await response.json();
      setIsModalOpen(false);
      toast.success(result.message, {
      style: {
        background: "green",
        color: "white",
      },
});
      fetchPaymentRequests();

      return result;
    
  };

 export const GetReserveAmount = async (ClaimNumber, reserveType, setIsLoading, setPolicyDetails, setCustomerDetails, setHasReserve, toast) => {
  
    const url = `${API_Payment_URL}Payment/GetReserveAmount`;
    const data = {
      ClaimNumber: ClaimNumber,
      ReserveType: reserveType
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        setPolicyDetails({
              Quote: "",
              ProductName: "",
              TotalAmount: "",
              Make: "",
              Model: "",
              Plate: "",
              desc: "",
            });
  
            setCustomerDetails({
              FirstName: "",
              lastName: "",
              email: "",
              phone: "",
            });
        setHasReserve(false);
        setIsLoading(false);
        return errorDetails;
      }

      const result = await response.json();
      setPolicyDetails({
                Quote: ClaimNumber,
                ProductName: "Claim",
                TotalAmount: parseFloat(result.Amount)
              });
              setHasReserve(true);
      setIsLoading(false);
      return result;
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
      setPolicyDetails({
              Quote: "",
              ProductName: "",
              TotalAmount: "",
              Make: "",
              Model: "",
              Plate: "",
              desc: "",
            });
  
            setCustomerDetails({
              FirstName: "",
              lastName: "",
              email: "",
              phone: "",
            });
            setHasReserve(false);
    }
  };


   export const GetDepReserveAmount = async (ClaimNumber, reserveType, setIsLoading, setPolicyDetails, setCustomerDetails, setHasReserve, toast) => {
  
    const url = `${API_Payment_URL}Payment/GetReserveAmount`;
    const data = {
      ClaimNumber: ClaimNumber,
      ReserveType: reserveType
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        if(errorDetails.message == "reserve not found"){
          setPolicyDetails({
                Quote: ClaimNumber,
                ProductName: "Claim",
              });
          setHasReserve(false);
                setIsLoading(false);
          return errorDetails;
        }
        else{
        toast.error(errorDetails.message, {
                  style: {
                    background: "#ffcccc",
                    color: "black",
                    fontWeight: "bold",
                  },
                });
                // setPolicyDetails({
                //       Quote: "",
                //       ProductName: "",
                //       TotalAmount: "",
                //       Make: "",
                //       Model: "",
                //       Plate: "",
                //       desc: "",
                //     });
          
                //     setCustomerDetails({
                //       FirstName: "",
                //       lastName: "",
                //       email: "",
                //       phone: "",
                //     });
                setHasReserve(false);
                setIsLoading(false);
        }
        
        return errorDetails;
      }

      const result = await response.json();
      if(result.Amount == "0"){
        setPolicyDetails({
                Quote: ClaimNumber,
                ProductName: "Claim",
              });
        setHasReserve(false);
        setIsLoading(false);
        return result;
      }
      else{
        toast.error("The reserve has already been created. Kindly clear the reserve in the core system.", {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        setPolicyDetails({
              Quote: "",
              ProductName: "",
              TotalAmount: "",
              Make: "",
              Model: "",
              Plate: "",
              desc: "",
            });
  
            setCustomerDetails({
              FirstName: "",
              lastName: "",
              email: "",
              phone: "",
            });
        setHasReserve(false);
        setIsLoading(false);
      }
      
      return result;
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
      setPolicyDetails({
              Quote: "",
              ProductName: "",
              TotalAmount: "",
              Make: "",
              Model: "",
              Plate: "",
              desc: "",
            });
  
            setCustomerDetails({
              FirstName: "",
              lastName: "",
              email: "",
              phone: "",
            });
            setHasReserve(false);
    }
  };

  // Reports/UserPaymentSummary
export const GetUserPaymentSummary = async (
  Token,
  toast,
  onSuccess // optional: e.g., (data) => setReport(data)
) => {
  const url = `${API_Payment_URL}Requests/user-payment-requests-status-report`;
  const data = { token: Token };

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    // expect { message: "...", ... } from backend SimpleException
    let errorDetails;
    try {
      errorDetails = await response.json();
    } catch {
      errorDetails = { message: "Failed to load report." };
    }

    toast?.error(errorDetails.message || "Failed to load report.", {
      style: {
        background: "#ffcccc",
        color: "black",
        fontWeight: "bold",
      },
    });

    return errorDetails; // keep parity with your other helper
  }

  const result = await response.json();

  // optional success toast (usually you don't toast on reads, but up to you)
  // toast?.success("Report loaded");

  onSuccess?.(result);
  return result;
};

// RequestsServices.js

// RequestsServices.js

export const GetPaidCollectionsReport = async (
  Token,
  toast,
  onSuccess, // optional: (data) => setState(data)
  opts = {}  // { department?: string, channel?: string, username?: string }
) => {
  const dep = typeof opts.department === "string" ? opts.department.trim() : "";
  const ch  = typeof opts.channel === "string" ? opts.channel.trim() : "";
  const un  = typeof opts.username === "string" ? opts.username.trim() : "";

  const params = new URLSearchParams();
  if (dep) params.set("department", dep);
  if (ch)  {
    params.set("channel", ch);
  } else if (un) {
    // only include username when channel is not supplied
    params.set("username", un);
  }

  const qs = params.toString();
  const url = `${API_Payment_URL}reports/paid${qs ? `?${qs}` : ""}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Token: Token,
      },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load report." };
      }

      toast?.error(errorDetails.message || "Failed to load report.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      // return a consistent error shape so UI can decide not to render
      return { ...errorDetails, error: true };
    }

    const result = await response.json();
    onSuccess?.(result);
    return result;
  } catch (err) {
    toast?.error("Failed to load report.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load report.", error: true };
  }
};

export const GetUsersByDepartment = async (
  Token,
  department,
  toast,
  onSuccess // optional: (list) => setUsers(list)
) => {
  const dep = (department || "").trim();
  const params = new URLSearchParams();
  if (dep) params.set("department", dep);

  const qs = params.toString();
  const url = `${API_Payment_URL}reports/GetUsersByDepartment${qs ? `?${qs}` : ""}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Token: Token,
      },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load users." };
      }

      toast?.error(errorDetails.message || "Failed to load users.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    const list = await response.json(); // expected: Array<{ userId, userName }>
    onSuccess?.(list);
    return list;
  } catch (err) {
    toast?.error("Failed to load users.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load users.", error: true };
  }
};




// Department leaderboard by month (new)
// GET Collections/department-month?year=YYYY&month=MM
// RequestsServices.js

// Get TCS All Funds List - Fund Information Report
export const GetTCSAllFundsList = async (toast) => {
  const url = `${API_BASE_URL}Life/TCSAllFundsList?type=FundInformation`;

  // Extended timeout for slow API (2 minutes)
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 120000);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load fund information." };
      }

      toast?.error(errorDetails.message || "Failed to load fund information.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    const result = await response.json();
    return result;
  } catch (err) {
    toast?.error("Failed to load fund information.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load fund information.", error: true };
  }
};

// Get Fund Information (paginated + searchable, served by payment API)
export const GetFundInformation = async ({ page = 1, pageSize = 10, search = "", toast } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (search) params.append("search", search);

  const url = `${API_Payment_URL}reports/FundInformation?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load fund information." };
      }

      toast?.error(errorDetails.message || "Failed to load fund information.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    return await response.json();
  } catch (err) {
    toast?.error("Failed to load fund information.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load fund information.", error: true };
  }
};

// Get Fund Performance (paginated + searchable, served by payment API)
export const GetFundPerformance = async ({ page = 1, pageSize = 10, search = "", toast } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (search) params.append("search", search);

  const url = `${API_Payment_URL}reports/FundPerformance?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load fund performance." };
      }

      toast?.error(errorDetails.message || "Failed to load fund performance.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    return await response.json();
  } catch (err) {
    toast?.error("Failed to load fund performance.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load fund performance.", error: true };
  }
};

// Get Fund Fees (paginated + searchable, served by payment API)
export const GetFundFees = async ({ page = 1, pageSize = 10, search = "", toast } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (search) params.append("search", search);

  const url = `${API_Payment_URL}reports/FundFees?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load fund fees." };
      }

      toast?.error(errorDetails.message || "Failed to load fund fees.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    return await response.json();
  } catch (err) {
    toast?.error("Failed to load fund fees.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load fund fees.", error: true };
  }
};

// Get TCS All Funds List - Performance Report
export const GetTCSPerformanceList = async (toast) => {
  const url = `${API_BASE_URL}Life/TCSAllFundsList?type=Performance`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },  
    });
  

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load performance data." };
      }

      toast?.error(errorDetails.message || "Failed to load performance data.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    const result = await response.json();
    return result;
  } catch (err) {
    toast?.error("Failed to load performance data.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load performance data.", error: true };
  }
};

// Get TCS All Funds List - Fund Fees Report
export const GetTCSFundFeesList = async (toast) => {
  const url = `${API_BASE_URL}Life/TCSAllFundsList?type=FundFees`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load fund fees." };
      }

      toast?.error(errorDetails.message || "Failed to load fund fees.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return { ...errorDetails, error: true };
    }

    const result = await response.json();
    return result;
  } catch (err) {
    toast?.error("Failed to load fund fees.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load fund fees.", error: true };
  }
};

export const GetDepartmentMonthSummary = async (
  Token,
  year,
  month,
  toast,
  onSuccess,          // optional: (data) => setState(data)
  opts = {}           // <- NEW: { department?: string }
) => {
  const params = new URLSearchParams({
    year: String(year),
    month: String(month),
  });

  // pass ?department=... only if provided
  if (opts.department && String(opts.department).trim()) {
    params.set("department", String(opts.department).trim());
  }

  const url = `${API_Payment_URL}reports/department-month?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Token: Token, // custom auth header
      },
    });

    if (!response.ok) {
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: "Failed to load department summary." };
      }

      toast?.error(errorDetails.message || "Failed to load department summary.", {
        style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
      });

      return errorDetails;
    }

    const result = await response.json();
    onSuccess?.(result);
    return result;
  } catch (err) {
    console.error(err);
    toast?.error("Failed to load department summary.", {
      style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
    });
    return { message: "Failed to load department summary.", error: true };
  }
};

